import {FormattedMessage, injectIntl} from '@meiko/react-intl';
import PanelHeaderTitle from 'components/generic/PanelHeaderTitle';
import Panel from 'components/generic/Panel';
import React from 'react';
import {Doughnut} from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {currencyOptions} from 'utils/numberFormat';

const teleKeys = ['Tele'];
const d2dKeys = ['D2D'];
const marketingKeys = ['Markkinointi', 'Marketing', 'Marknadsföring'];
const salesKeys = ['Myynti IH', 'Sales', 'Självanskaffad'];

/**
 *
 * A bit hacky solution to get colors by label
 * The keys can be in different languages and we other way to differentiate them than by label
 * @param {string} label
 * @returns {{bg: string, fg: string}}
 */
export const getColorsByLabel = label => {
	if (teleKeys.includes(label)) {
		return {
			bg: 'rgba(255, 99, 132, 1)',
			fg: 'rgba(255, 99, 132, 1)',
		};
	}
	if (d2dKeys.includes(label)) {
		return {
			bg: 'rgba(54, 162, 235, 1)',
			fg: 'rgba(54, 162, 235, 1)',
		};
	}
	if (marketingKeys.includes(label)) {
		return {
			bg: 'rgba(75, 192, 192, 1)',
			fg: 'rgba(75, 192, 192, 1)',
		};
	}
	if (salesKeys.includes(label)) {
		return {
			bg: 'rgba(255, 206, 86, 1)',
			fg: 'rgba(255, 206, 86, 1)',
		};
	}
	return {fg: 'rgba(0, 0, 0, 1)', bg: 'rgba(0, 0, 0, 1)'};
};

const SalesBySourcesChart = ({data, intl}) => {
	const {total, ...rest} = data || {};
	const dataKeys = Object.keys(rest);
	const labels = dataKeys.map(key => `${key}`);

	const options = {
		indexAxis: 'y',
		responsive: true,
		plugins: {
			legend: {
				position: 'right',
			},
			datalabels: {
				formatter: value => {
					return `${Math.round((value / total) * 100 || 0)}%`;
				},
			},
			tooltip: {
				callbacks: {
					label: function (context) {
						return `${context.label}: ${intl.formatNumber(context.raw, currencyOptions)}`;
					},
				},
			},
		},
	};

	const chartData = {
		labels,
		datasets: [
			{
				data: dataKeys.map(key => data[key] ?? 0),
				backgroundColor: dataKeys.map(key => getColorsByLabel(key).bg),
				borderColor: dataKeys.map(key => getColorsByLabel(key).fg),
				borderWidth: 1,
			},
		],
	};

	return (
		<Panel
			header={
				<PanelHeaderTitle>
					<FormattedMessage id="Sales by source" />
					{' - '}
					<FormattedMessage id="Percentage (%)" />
				</PanelHeaderTitle>
			}
		>
			<>
				{data && total > 0 && (
					<Doughnut options={options} data={chartData} plugins={[ChartDataLabels]} />
				)}
				{!data ||
					(total === 0 && (
						<div className="py-3 text-xs text-gray-400">
							<FormattedMessage id="Not enough data" />
						</div>
					))}
			</>
		</Panel>
	);
};

export default injectIntl(SalesBySourcesChart);
